//форматирования времени в мин:сек
import { EventOrganizer } from "../types/types";

export const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${String(minutes).padStart(1, "0")}:${String(
    remainingSeconds
  ).padStart(2, "0")}`;
};

//форматирование времени в формат "Понедельник, 27 янв. в 20:30"
export const formatDate = (dateString: string) => {
  const date = new Date(dateString);

  const daysOfWeek = [
    "Воскресенье",
    "Понедельник",
    "Вторник",
    "Среда",
    "Четверг",
    "Пятница",
    "Суббота",
  ];
  const months = [
    "янв",
    "фев",
    "мар",
    "апр",
    "май",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек",
  ];

  const day = date.getDate();
  const dayOfWeek = daysOfWeek[date.getDay()];
  const month = months[date.getMonth()];
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${dayOfWeek}, ${day} ${month} в ${hours}:${minutes}`;
};

//поиск минимальной стоимости билета
export const getMinPrice = (
  tickets: NonNullable<EventOrganizer["ticket_types_data"]>
) => {
  if (tickets.length > 0) {
    return Math.min(...tickets.map((ticket) => ticket.price));
  } else {
    return "Бесплатно";
  }
};

//получение ширины текста в px
export const getTextWidth = (
  text = "",
  fontSize: string,
  fontWeight = "normal",
  fontFamily = "Arial"
) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  if (context === null) {
    return 0;
  }
  context.font = `${fontWeight} ${fontSize} ${fontFamily}`;
  return context.measureText(text).width;
};

//проверка авторизации пользователя
export const checkAuth = () => {
  const token = document.cookie
    .split(";")
    .some((c) => c.trim().startsWith("authToken="));
  return token;
};

//получение токена
export const getAuthToken = () => {
  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("authToken="))
    ?.split("=")[1];
};
